export default () => {
  const accors = document.querySelectorAll('[data-accor]');

  const toggleAccorHeight = (el, target) => {
    const height = el.classList.contains("active") ? `${target.scrollHeight}px` : `0rem`;
    target.style.setProperty('--accor-height', height);
  };

  const init = (el) => {
    const [ctrl, target] = [
      el.querySelector('[data-accor-ctrl]'),
      el.querySelector('[data-accor-target]'),
    ];
  
    toggleAccorHeight(el, target);

    ctrl.addEventListener('click', (e) => {
      e.stopPropagation();

      accors.forEach((ele) => {
        const target = ele.querySelector('[data-accor-target]');
        target.style.setProperty('--accor-height', `0rem`);
        ele != el && ele.classList.remove('active');
      });
  
      el.classList.toggle('active');
      toggleAccorHeight(el, target);
    }, { passive: true });
  };

  accors.forEach(init);
  window.accorInit = init;
}